import type { ReactElement } from 'react';

import { VerticalTrackerContainer } from './styles';
import type { TrackerBarPositionVariant, TrackerBarVariant } from './types';
import { VerticalTrackerStep } from './VerticalTrackerStep';

export interface VerticalTrackerProps {
  steps: ReactElement[];
  currentStepIdx: number;
  variant: 'active' | 'inactive';
  iconOverride?: ReactElement;
}

export const VerticalTracker = ({ steps, currentStepIdx, variant, iconOverride }: VerticalTrackerProps) => {
  return (
    <VerticalTrackerContainer>
      {steps.map((step, idx) => {
        const isFirst = idx === 0;
        const isLast = idx === steps.length - 1;
        const isCurrent = idx === currentStepIdx;
        const isPast = idx <= currentStepIdx;
        const isActive = variant === 'active';
        const positionVariant: TrackerBarPositionVariant = isFirst ? 'first' : isLast ? 'last' : 'middle';
        const barVariant: TrackerBarVariant = !isPast
          ? 'future'
          : isActive
          ? 'active'
          : isCurrent
          ? 'inactiveCurrent'
          : 'inactive';
        return (
          <VerticalTrackerStep
            position={positionVariant}
            barVariant={barVariant}
            isCurrent={isCurrent}
            iconOverride={iconOverride}
            key={idx}
          >
            {step}
          </VerticalTrackerStep>
        );
      })}
    </VerticalTrackerContainer>
  );
};
